import React from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { fileNotFound } from '../../assets/images/icons';

const OrderCard = ({ data }) => {
  const { t } = useTranslation();
  const localImg = process.env.REACT_APP_LOCALHOST_IMG;
  const productName = JSON.parse(data.product_name);
  const category = JSON.parse(data.category_name);
  const image = JSON.parse(data.imgs);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 py-3 border-b border-gray-200">
      <div className="space-y-4 md:space-y-0 md:flex md:items-center md:gap-4">
        <div className="w-full md:w-auto p-4 bg-gray-50 rounded-lg">
          <img loading="lazy" src={image? localImg + image[0]:fileNotFound} alt="product" className="w-full md:w-24 md:h-24 h-auto aspect-square object-cover rounded-md" />
        </div>

        <div className="flex-1 space-y-2">
          <a href={`/product/${data.slug}`} className="block text-lg font-medium text-black hover:text-orange-600 transition-colors">
            {productName[i18n.language]}
          </a>

          <div className="flex flex-wrap gap-x-2 text-sm text-gray-500">
            <span>{category[i18n.language]}</span>
            {" | "}
            {data.size_name && <span>Size: {data.size_name}</span>}
          </div>

          <p className="text-xs text-gray-500">
            {t("product")} ID #{data.num_product}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between md:justify-end gap-4 pt-2 md:pt-0">
        <div className="flex items-baseline gap-2">
          <span className="text-gray-500 text-base">{data.total_quantity} x</span>
          <span className="text-lg font-medium">
            {parseFloat(data.price).toFixed(2)} <span className="text-xs leading-none pb-[1px]">MAD</span>
          </span>
        </div>

        <div className="text-lg font-semibold text-black/80">
          = {data.total_amount} <span className="text-xs leading-none pb-[1px]">MAD</span>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;